import { t, Lang } from './i18n'

// Issue #45, 2026-10-02: "columnas finas, con un pequeño icono/pestaña por columna que al pulsar
// muestre las mismas tres opciones". Antes esto era un <select> nativo a lo ancho de toda la
// cabecera de cada sesión, ensanchando la columna; ahora es un botón pequeño (el trigger) que abre
// este menú flotante con las mismas tres opciones y el mismo comportamiento.
// Compartido por F11 (donde nació) y por Eskola/F7 (`AsistenciaTab.tsx`, issue #52, 2026-10-02:
// "en F7 y UKE Eskola, añade una mini pestañita... las mismas tres opciones").
export function EstadoDiaMenu({
  x,
  y,
  lang,
  onTodos,
  onFestivo,
  onSuspendido,
  onClose,
}: {
  x: number
  y: number
  lang: Lang
  onTodos: () => void
  onFestivo: () => void
  onSuspendido: () => void
  onClose: () => void
}) {
  const menuWidth = 220
  const left = Math.min(x, Math.max(8, window.innerWidth - menuWidth - 8))
  const top = Math.min(y, Math.max(8, window.innerHeight - 160 - 8))

  function elegir(accion: () => void) {
    accion()
    onClose()
  }

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 100 }} />
      <div
        role="menu"
        style={{
          position: 'fixed',
          top,
          left,
          width: menuWidth,
          zIndex: 101,
          background: 'var(--color-surface-card)',
          color: 'var(--color-text-primary)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-md)',
          padding: 8,
        }}
      >
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          <li>
            <button onClick={() => elegir(onTodos)} style={{ minHeight: 44, width: '100%', justifyContent: 'flex-start' }}>
              {t('estadoDiaTodos', lang)}
            </button>
          </li>
          <li>
            <button onClick={() => elegir(onFestivo)} style={{ minHeight: 44, width: '100%', justifyContent: 'flex-start', marginTop: 4 }}>
              {t('estadoDiaFestivo', lang)}
            </button>
          </li>
          <li>
            <button onClick={() => elegir(onSuspendido)} style={{ minHeight: 44, width: '100%', justifyContent: 'flex-start', marginTop: 4 }}>
              {t('estadoDiaSuspendido', lang)}
            </button>
          </li>
        </ul>
      </div>
    </>
  )
}
